import { render, staticRenderFns } from "./topicChangeApplication.vue?vue&type=template&id=63b375fd&scoped=true&"
import script from "./topicChangeApplication.vue?vue&type=script&lang=js&"
export * from "./topicChangeApplication.vue?vue&type=script&lang=js&"
import style0 from "./topicChangeApplication.vue?vue&type=style&index=0&id=63b375fd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b375fd",
  null
  
)

export default component.exports